import { makeStyles } from '@material-ui/core/styles'
import PageMetaData, { BUTTON_SIZE } from '@v4/utils/data/PageMetaData'

const useStyles = makeStyles(
	theme => ({
		root: {
			[theme.breakpoints.down('xs')]: {
				width: `calc(100% + ${theme.spacing(4)})`,
				margin: theme.spacing(-2.5, -2),
			},
		},
		video: {},
		content: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			textAlign: 'center',
			[theme.breakpoints.up('md')]: {
				alignItems: 'flex-start',
				textAlign: 'left',
			},
		},
		text: {
			marginBottom: theme.spacing(3),

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => (mobileAlignment ? `${mobileAlignment} !important` : null),
				},
			},
		},
		empty: {
			[theme.breakpoints.down('sm')]: {
				display: 'none',
			},
		},
		videoContainer: {},

		buttonContainer: {
			[theme.breakpoints.down('sm')]: {
				width: '100%',
				display: 'flex',
				justifyContent: ({ mobileAlignment }) => PageMetaData.CONTENT_ALIGNMENT[mobileAlignment] || null,
			},
		},
		button: {
			width: 'auto',

			[theme.breakpoints.down('sm')]: {
				width: ({ mobileButtonWidth }) => (mobileButtonWidth === BUTTON_SIZE.WIDE ? '100%' : 'auto'),
			},
		},
		textContainer: {},
	}),
	{ name: 'Video-Content4' },
)

export default useStyles
